'use strict';

import * as util from '../util/Common.js';
import {EventManager} from '../util/EventManager.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import {RelativeContainer} from '../ui/RelativeContainer.js';
import {SequenceController} from '../viewer/SequenceView.js';
import {Annotation2DListResource} from '../content/BoxContent.js';
import {DataTypes} from '../viewer/DomItem.js';

const privateMap = util.createPrivateMapper();

function vint(v){
  return v.toFixed(0);
};
function vintStr(v){
  return parseInt(v, 10) | 0;
};

export const JsonLdUtil = {
  convertXywh: function(v){
    const xywh = v.split(',');
    if (xywh.length != 4) {
      console.error('invalid xywh. fragment:' + v);
    }
    const rect = {x: vintStr(xywh[0]), y: vintStr(xywh[1]), width: vintStr(xywh[2]), height: vintStr(xywh[3])};
    return rect;
  },

  getLdField: function(obj, field) {
    const v = obj[field];
    if (v == null) {
      return null;
    }
    if (util.isArray(v)) {
      return v;
    }
    return [v];
  },

  checkContext: function(contexts, targetContexts) {
    let flag = false;
    util.each(contexts, (context) => {
      if (targetContexts[context]){
        flag = true;
        return false;
      }
    });
    return flag;
  }
}

function getTargetAnalyzers(pv, json){
  const targetAnalyzers = [];
  util.each(pv.analyzers, (analyzer) => {
    if (analyzer.isTarget(json)) {
      targetAnalyzers.push(analyzer);
    }
  });
  return targetAnalyzers;
}

function analyze(url, pv, json, successCallback, params){
  const targetAnalyzers = getTargetAnalyzers(pv, json);
  if (!targetAnalyzers.length) {
    if (params.failure) {
      params.failure(new Error('unknown analyzer'));
    }
    return;
  }
  const manifest = {
    id: url,
    metadata: {},
    sequences: [],
    structures: []
  };
  util.each(targetAnalyzers, (analyzer) => {
    analyzer.analyze(json, manifest);
  })
  util.each(manifest.sequences, (seq) => {
    util.each(seq.scenes, (scene) => {
      scene.manifest = manifest
      scene.type = pv.resolveResourceLoader(scene.source);
    });
  });
  successCallback(manifest);
}

export class JsonLdManifestLoader extends EventManager {
  constructor(options){
    super();
    const pv = privateMap(this);
    pv.analyzers = [...options.analyzers];
    pv.resolveResourceLoader = options.resolveResourceLoader;
  }

  loadManifest(url, successCallback, params) {
    const pv = privateMap(this);
    let xhr;
    const p = Object.assign({}, params, {
      url: url,
      success: function(xhr){
        let json;
        try {
          json = JSON.parse(xhr.responseText);
        } catch (error) {
          if (params.failure) {
            params.failure(error);
          }
          return;
        }
        analyze(url, pv, json, successCallback, params);
      }
    });
    xhr = util.ajax(p);
    return xhr;
  }

  loadAnnotationList(annoListInfo, successCallback, params){
    const pv = privateMap(this);
    let xhr;
    if (annoListInfo.type == 'direct') {
      const targetResources = [];

      util.each(annoListInfo.regions, (rgn) => {
        const rect = rgn.rect
        const obj = {
          resource: {
            '@type': 'cnt:ContentAsText',
            'format': 'text/plain',
            'chars': rgn.char
          },
          xywh: {x: rect[0], y:rect[1], width: rect[2], height: rect[3]}
        };
        targetResources.push(obj)
      });
      const res = new Annotation2DListResource('manifest:' + annoListInfo.id);
      res.addRegions(targetResources);
      successCallback(res)
      return false
    }
    const p = Object.assign({}, params, {
      url: annoListInfo.id,
      success: function(xhr){
        let json;
        try {
          json = JSON.parse(xhr.responseText);
        } catch (error) {
          if (params.failure) {
            params.failure(error);
          }
          return;
        }
        const targetAnalyzers = getTargetAnalyzers(pv, json);
        if (targetAnalyzers == null || !targetAnalyzers.length) {
          console.error('annotation analyzer not found.', json);
          if (params.failure) {
            params.failure(new Error('annotation analyzer not found.'));
            return;
          }
        }
        const res = new Annotation2DListResource('manifest:' + annoListInfo.id);
        util.each(targetAnalyzers, (analyzer) => {
          analyzer.analyzeAnnotationList(json, res);
        });
        successCallback(res);
        // ayanlyze(pv, json, successCallback, params);
      }
    });
    xhr = util.ajax(p);
    return xhr;
  }
}
